import { createConsumer, createSubscriber, IEvent } from '@cian/events-log';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  trackRecommendationsView,
  trackRecommendationItemClick,
  trackTrapRecommendationClick,
  trackRecommendationsTrapView,
} from '../tracking';
import { TRecommendationsEvent } from './types';
import { selectDealType } from '../../../utils/jsonQuery/selectDealType';
import { TSectionType } from '../../../types/sectionType';

export const useRecommendationsEventsSubscribe = (section: TSectionType) => {
  const dealType = useSelector(selectDealType);

  useEffect(() => {
    const consumer = createConsumer({ topic: 'recommendations' });

    const recommendationsSubscriber = createSubscriber((event: IEvent<unknown>) => {
      const eventData = event as TRecommendationsEvent;

      switch (eventData.type) {
        case 'show':
          trackRecommendationsView(dealType, section, eventData.value);

          break;
        case 'click': {
          const { suffix, offerId } = eventData.value;

          if (offerId) {
            trackRecommendationItemClick(dealType, section, eventData.value.products);
          } else if (suffix) {
            trackTrapRecommendationClick(dealType, suffix, section);
          }

          break;
        }
        case 'showTrap':
          trackRecommendationsTrapView(dealType, eventData.value.suffix, section);

          break;
      }
    });

    consumer.subscribe(recommendationsSubscriber);

    return () => {
      consumer.unsubscribe(recommendationsSubscriber);
      consumer.destroy();
    };
  });
};
